module.exports = " <section class=\"hero is-primary\"> <div class=hero-body> <div class=container> <h1 class=title> Morse Code </h1> <h2 class=subtitle> 摩斯電碼編解碼工具 </h2> </div> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
 ** module id = 163
 ** module chunks = 2
 **/